import { Box, FormField, Heading, Input, Label, Paragraph, Text } from '@zillow/constellation-10';

import { SpotIllustration } from '@zg-rentals/visual-cohesion';

import type { ChangeEvent } from 'react';

type NameFieldsProps = {
  firstName: string;
  lastName: string;
  onFirstNameChange: (e: ChangeEvent<HTMLInputElement>) => void;
  onLastNameChange: (e: ChangeEvent<HTMLInputElement>) => void;
  questionNumber: number;
  questionTotal: number;
};

export const NameFields = ({
  firstName,
  lastName,
  onFirstNameChange,
  onLastNameChange,
  questionNumber,
  questionTotal,
}: NameFieldsProps) => {
  return (
    <Box
      css={{
        display: 'flex',
        flexDirection: 'column',
        gap: '500',
        alignItems: 'flex-start',
        width: '100%',
      }}
    >
      <SpotIllustration name="agent-buyer-handshake" />
      <Box css={{ display: 'flex', flexDirection: 'column', gap: '200' }}>
        <Text textStyle="body-xs-bold" css={{ color: 'text.subtle' }}>
          Question {questionNumber} of {questionTotal}
        </Text>
        <Heading level={2} textStyle="heading-xs">
          What’s your name?
        </Heading>
        <Paragraph>We’ll use this to personalize your experience.</Paragraph>
      </Box>
      <Box css={{ display: 'flex', flexDirection: 'column', gap: '400', width: '100%' }}>
        <FormField
          label={<Label>First name</Label>}
          control={<Input value={firstName} onChange={onFirstNameChange} />}
        />
        <FormField label={<Label>Last name</Label>} control={<Input value={lastName} onChange={onLastNameChange} />} />
      </Box>
    </Box>
  );
};

export default NameFields;
